import { fetchApi } from '@/config/api'

export interface ProductManagerCguStatus {
  accepted: boolean
  cguVersion?: string | null
  acceptedAt?: string | null
}

export async function getProductManagerCguStatus(): Promise<ProductManagerCguStatus> {
  const query = `
    query ProductManagerCguStatus {
      productManagerCguStatus {
        accepted
        cguVersion
        acceptedAt
      }
    }
  `

  const result = await fetchApi<{ productManagerCguStatus: ProductManagerCguStatus }>(
    query,
  )
  return result.productManagerCguStatus
}

export async function acceptProductManagerCgu(): Promise<ProductManagerCguStatus> {
  const query = `
    mutation AcceptProductManagerCgu {
      acceptProductManagerCgu {
        accepted
        cguVersion
        acceptedAt
      }
    }
  `

  const result = await fetchApi<{ acceptProductManagerCgu: ProductManagerCguStatus }>(
    query,
  )
  return result.acceptProductManagerCgu
}
